/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserByIdRoleResponse } from './user-by-id-role-response';
import { UserByIdStatusResponse } from './user-by-id-status-response';


export interface UserByIdResponse { 
    id: string;
    login: string;
    email?: string | null;
    emailConfirmed: boolean;
    isAuthenticatorEnabled: boolean;
    role: UserByIdRoleResponse;
    status: UserByIdStatusResponse;
    blockReason?: string | null;
    blockedByAdmin?: string | null;
}

